import React, { useState } from "react";
import { Search, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import SignalCard from "./SignalCard";
import api from "../lib/api";

export function TradeSearch() {
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);

  const search = async (e) => {
    e?.preventDefault();
    const id = q.trim();
    if (!id) return;
    setLoading(true);
    setError("");
    try {
      const { data } = await api.get(`/signals/search`, { params: { seq: parseInt(id, 10) } });
      setResult(data);
      setOpen(true);
    } catch (err) {
      setResult(null);
      setError(err.response?.status === 404 ? `Nessun trade con ID ${id}` : "Errore nella ricerca");
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mb-8" data-testid="trade-search">
      <h2 className="text-sm text-zinc-500 uppercase tracking-wider mb-3">Cerca trade per ID</h2>
      <form onSubmit={search} className="flex items-center gap-2 max-w-md">
        <div className="relative flex-1">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
          <input
            data-testid="trade-search-input"
            type="number"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Es. 100324"
            className="w-full pl-9 pr-3 py-2.5 rounded-md bg-[#141414] border border-white/10 text-white text-sm font-mono focus:border-blue-500 focus:outline-none transition-colors"
          />
        </div>
        <button
          data-testid="trade-search-btn"
          type="submit"
          disabled={loading}
          className="px-5 py-2.5 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-500 transition-colors disabled:opacity-50"
        >
          {loading ? "..." : "Cerca"}
        </button>
      </form>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="trade-search-modal" className="max-w-md bg-[#0d0d0d] border-white/10 text-white">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-lg">
              <Search size={18} className="text-blue-400" />
              Risultato ricerca
            </DialogTitle>
          </DialogHeader>
          {error ? (
            <div data-testid="trade-search-error" className="flex items-center gap-2 py-8 justify-center text-zinc-400 text-sm">
              <X size={16} className="text-red-400" /> {error}
            </div>
          ) : result ? (
            <div className="space-y-3">
              {result.pnl !== undefined && result.pnl !== null && (
                <div className={`text-center font-mono text-lg font-semibold ${result.pnl >= 0 ? "text-emerald-400" : "text-red-400"}`}>
                  {result.pnl >= 0 ? "+" : "-"}{Math.abs(result.pnl).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}$ {result.pnl >= 0 ? "PROFIT" : "LOSS"}
                </div>
              )}
              <SignalCard s={result} />
            </div>
          ) : null}
        </DialogContent>
      </Dialog>
    </div>
  );
}
